module.exports = __webpack_public_path__ + "static/media/time.599c4eb9.png";